"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var _default = function _default(storyCardTags, categories, activeFilters, showAllStories, numberOfFiltersSelected) {
  if (!storyCardTags) return false;
  if (!storyCardTags.length) return false;
  if (showAllStories) return true;
  if (numberOfFiltersSelected === 0) return true;
  var targetCategories = categories.reduce(function (accumulator, category) {
    if (activeFilters[category].length > 0) {
      return [].concat(_toConsumableArray(accumulator), [category]);
    }

    return accumulator;
  }, []);

  for (var i = 0; i < targetCategories.length; i += 1) {
    var fulfillsTargetCategory = false;
    activeFilters[targetCategories[i]].forEach(function (tag) {
      if (storyCardTags.includes(tag)) {
        fulfillsTargetCategory = true;
      }
    });
    if (!fulfillsTargetCategory) return false;
  }

  return true;
};

exports["default"] = _default;